import {Box, CircularProgress, circularProgressClasses, styled, Typography} from '@mui/material';

export const StyledBox = styled(Box)`
	margin-top: 28px;
	margin-inline: auto;
	position: relative;
	width: 'max-content';
`;

export const StyledCircularProgress = styled(CircularProgress)`
	position: absolute;
	left: 0;

	& .${circularProgressClasses.circle} {
		stroke-linecap: round;
	}
`;
export const TokenNumberContainer = styled(Box)`
	inset: 0;
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TokenNumber = styled(Typography)`
	font-size: 32px;
	font-weight: 700;
	letter-spacing: 3px;
`;
